import React, { useEffect, useRef, useState } from "react";
import NavBar from "../../../Components/Navbar/navbar";
import styles from "../../Styles/tables.module.css";
import { Url, getUser } from "../../../Constants/globals";
import { TbArrowBigLeftLineFilled, TbArrowBigRightLineFilled } from "react-icons/tb";
import axios from "axios";
import RefreshToken from "../../../Components/RefreshToken/RefreshToken";
import { HiPencil, HiPlus, HiTrash, HiSearch, HiX, HiCheck } from "react-icons/hi";
import DeleteModal from "../../../Components/DeleteModal/deletemodal";
import Alert from "../../../Components/Alert/alert";

async function getProtocolCategories(page){
  try {
    const res = await axios
    .get(`${Url}/protocol-types?page=${page ? page : 1}&order_by=name`, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await getProtocolCategories(page);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return [];
    }
  };
}

async function addCategory(nome, setField, file){
    if (nome === ""){
      return <Alert type={"error"}>O nome é um campo obrigatório!</Alert>;
    }
    try {
      const res = await axios
      .post(`${Url}/protocol-types`,
      {
        name: nome,
      }, {
        headers: {
          Authorization: "Bearer "+getUser().token,
        },
      });
      setField(false);
      if (file){
        const formData = new FormData();
        formData.append('file', file);
        await axios.post(`${Url}/protocol-types-icon/${res.data.id}`,
        formData, {
          headers: {
            Authorization: "Bearer "+getUser().token,
            'Content-Type': 'multipart/form-data'
          },
        });
      }
      return <Alert type={"success"}>Categoria adicionada com sucesso!</Alert>;
    }
    catch (err) {
      if (err.request && err.request.status === 401){
        var newToken = await RefreshToken(err);
        if (newToken) {
          return await addCategory(nome, setField, file);
        } else {
          window.location.reload();
        }
      }
      else {
        console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar a categoria");
        return <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar a categoria"}</Alert>;
      }
    };
  }

  async function editCategory(id, nome, file){
    if (nome === ""){
        return <Alert type={"error"}>O nome é um campo obrigatório!</Alert>;
    }
  try {
    await axios
    .put(`${Url}/protocol-types/${id}`,
    {
        name: nome,
    }, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    if (file){
      const formData = new FormData();
      formData.append('file', file);
      await axios.post(`${Url}/protocol-types-icon/${id}`,
      formData, {
        headers: {
          Authorization: "Bearer "+getUser().token,
          'Content-Type': 'multipart/form-data'
        },
      });
    }
    return <Alert type={"success"}>Categoria editada com sucesso!</Alert>;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await editCategory(id, nome, file);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar a categoria");
      return <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar a categoria"}</Alert>;
    }
  };
}

async function deleteCategory(id){
  try {
    await axios.delete(`${Url}/protocol-types/${id}`, {
      headers: {
        Authorization: "Bearer " + getUser().token,
      },
    });
    return [200, <Alert type={"success"}>Categoria eliminada com sucesso!</Alert>];
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await deleteCategory(id);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return  [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao eliminar a categoria"}</Alert>];
    }
  };
}

function ProtocolosCategorias({userPermissions}) {

  const searchRef = useRef(null);
  const addRef = useRef(null);
  const editRef = useRef(null);
  const fileInputRef = useRef(null);
  const fileInputRefAdd = useRef(null);
  const [loadingData, setLoadingData] = useState(true);

  const [deleteProtocol, setDeleteProtocol] = useState("");
  const [alert, setAlert] = useState("");

  const [categoriesData, setCategoriesData] = useState([]);
  const [previousPageCategories, setPreviousPageCategories] = useState("");
  const [nextPageCategories, setNextPageCategories] = useState("");
  const [currentPageCategories, setCurrentPageCategories] = useState("");

  const [showAdd, setShowAdd] = useState(false);
  const [isPoppedOutAdd, setIsPoppedOutAdd] = useState(false);
  const [nome, setNome] = useState("");

  const [showSearch, setShowSearch] = useState(false);
  const [isPoppedOutSearch, setIsPoppedOutSearch] = useState(false);
  const [nomeSearch, setNomeSearch] = useState("");

  const [editNome, setEditNome] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");

  const [file, setFile] = useState("");
  const [selectedFile, setSelectedFile] = useState("");
  const [fileAdd, setFileAdd] = useState("");
  const [selectedFileAdd, setSelectedFileAdd] = useState("");

  async function assignData() {
    const thisCategoriesData = await getProtocolCategories(currentPageCategories);
    setCurrentPageCategories(thisCategoriesData.current_page);
    setNextPageCategories(thisCategoriesData.next_page);
    setPreviousPageCategories(thisCategoriesData.prev_page);
    setCategoriesData(thisCategoriesData);
    setLoadingData(false);
  }

  useEffect(() => {
    assignData();
  }, []);
  
  async function handlePageChangeCategories(next) {
    if (next && nextPageCategories) {
      const newCategoriesData = await getProtocolCategories(nextPageCategories);
      setCategoriesData(newCategoriesData);
      setCurrentPageCategories(newCategoriesData.current_page);
      setNextPageCategories(newCategoriesData.next_page);
      setPreviousPageCategories(newCategoriesData.prev_page);
    }
    else if (!next && previousPageCategories) {
      const newCategoriesData = await getProtocolCategories(previousPageCategories);
      setCategoriesData(newCategoriesData);
      setCurrentPageCategories(newCategoriesData.current_page);
      setNextPageCategories(newCategoriesData.next_page);
      setPreviousPageCategories(newCategoriesData.prev_page);
    }
    else {
      return;
    }
  }

  const handleSearchContainer = (setIsPoppedOut, show, setShow, ref) => {
    if (show){
      setIsPoppedOut(true);
      setTimeout(() => {
        setShow(false);
        setIsPoppedOut(false);
      },280);
    } else {
      setShow(true);
      if (ref){
        setTimeout(() => {
          ref.current.focus();
        }, 280);
      }
    }
  }

  async function handleSearch(input) {
    if (input === false){
      setNomeSearch("");
    }
    const searchProtocolsData = await getProtocolCategories(1, input === false ? "" : nomeSearch);
    setCurrentPageCategories(searchProtocolsData.current_page);
    setNextPageCategories(searchProtocolsData.next_page);
    setPreviousPageCategories(searchProtocolsData.prev_page);
    setCategoriesData(searchProtocolsData);
  }

  async function getAlertAdd() {
    await setAlert("");
    const res = await addCategory(nome, setShowAdd, fileAdd);
    setAlert(res);
    assignData();
  }

  async function getAlertEdit() {
    await setAlert("");
    const res = await editCategory(selectedCategory.id, editNome, file);
    setAlert(res);
    assignData();
  }

  async function getAlertDelete(id) {
    if (id){
      await setAlert("");
      const res = await deleteCategory(id);
      setAlert(res[1]);
      assignData();
      return res;
    }
  }

  function handleEditButton(category) {
    setSelectedCategory(category);
    setEditNome(category.name);
    setSelectedFile(`${Url}/image/${category.uri}`);
    setTimeout(() => {
      editRef.current.focus();
    }, 280);
  }

  const handleImageUpload = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    setFile(event.target.files[0]);
    setSelectedFile(URL.createObjectURL(event.target.files[0]));
  };
  
  const handleImageUploadAdd = () => {
    fileInputRefAdd.current.click();
  };

  const handleFileChangeAdd = async (event) => {
    setFileAdd(event.target.files[0]);
    setSelectedFileAdd(URL.createObjectURL(event.target.files[0]));
  };

  return (
    <div className="body">
      {alert}
      {deleteProtocol}
      <NavBar current={"protocolos"} setDisappear={setLoadingData} userPermissions={userPermissions} />
      {
        loadingData ? ""
        :
        <div style={{position: "relative"}}>
          <div className={styles.tableButtons}>
            <button className={`${styles.btnAdd} ${showAdd ? styles.btnAddActive : ""}`} onClick={() => {setSelectedCategory(""); handleSearchContainer(setIsPoppedOutAdd, showAdd, setShowAdd, addRef);}}>
              <HiPlus size={20}/>
              <p className={styles.textAdd}>Adicionar</p>
            </button>
            <button className={`${styles.btnSearch} ${showSearch ? styles.btnSearchActive : ""}`} onClick={() => handleSearchContainer(setIsPoppedOutSearch, showSearch, setShowSearch, searchRef)}>
              <HiSearch size={20}/>
              <p className={styles.textAdd}>Procurar</p>
            </button>
          </div>
          <div className={styles.content}>
          {
            showAdd ?
              <div className={`${styles.container} ${showAdd ? styles.popin : ""} ${isPoppedOutAdd ? styles.popout : ""}`}  >
                <div style={{paddingRight: "10px"}}>
                  {
                    selectedFileAdd ?
                    <img className={styles.categoryIcon} alt="img" src={selectedFileAdd}/>
                    :
                    ""
                  }
                  <div className={styles.changeImage} onClick={() => handleImageUploadAdd()}>
                    <input
                      type="file"
                      ref={fileInputRefAdd}
                      onChange={(e) => handleFileChangeAdd(e)}
                      style={{display: "none"}}
                    />
                    <button className={styles.alterarIcon}>{selectedFileAdd ? "Alterar ícone" : "Escolher ícone"}</button>
                  </div>
                </div>
                <input 
                  className={styles.searchInput}
                  ref={addRef}
                  onChange={(e) => setNome(e.target.value)}
                  placeholder="Nome da categoria..."
                  value={nome}
                  style={{height: "fit-content", alignSelf: "flex-end"}}
                  onKeyDown={(event) => {
                    if (event.key === "Escape"){
                      setShowAdd(false);
                    }
                    else if (event.key === "Enter") {
                      getAlertAdd();
                    }
                  }}
                />
                <div style={{backgroundColor: "var(--inputBackground)", display: "flex", borderTopRightRadius: "4px", borderBottomRightRadius: "4px", height: "fit-content", alignSelf: "flex-end"}}>
                  <button className={styles.btn} style={{marginLeft: "0"}} onClick={() => getAlertAdd()}><HiPlus size={18}/></button>
                </div>
              </div>
            : ""
            }
            {
              showSearch ?
              <div className={`${styles.container} ${showSearch ? styles.popin : ""} ${isPoppedOutSearch ? styles.popout : ""}`}  >
                <input 
                  className={styles.searchInput}
                  ref={searchRef}
                  onChange={(e) => setNomeSearch(e.target.value)}
                  placeholder="Procurar"
                  value={nomeSearch}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      handleSearch();
                    }
                  }}
                />
                <div style={{backgroundColor: "var(--inputBackground)", display: "flex", borderTopRightRadius: "4px", borderBottomRightRadius: "4px"}}>
                  <button className={styles.btn} style={{cursor: "default", marginRight: "0"}} onClick={() => handleSearch(false)}><HiX size={16} color="#9c9c9c"/></button>
                  <button className={styles.btn} style={{marginLeft: "0"}} onClick={() => handleSearch()}><HiSearch size={18}/></button>
                </div>
              </div>
            : ""
            }
            <div className={styles.tableProtocolCategories}>
              <div className={styles.protocolCategoriesColumn}>
                <p></p>
                <p>Nome</p>
                <p>Ações</p>
              </div>
              <div className={styles.scrollContent}>
                {
                  categoriesData?.protocols?.length > 0 ?
                  categoriesData?.protocols?.map((protocol, index) =>
                    <div key={protocol.id} className={styles.protocolCategoriesInfo} style={ index % 2 !== 0 ? {backgroundColor: "var(--inputBackground)"} : {}}>
                      {
                        selectedCategory === protocol ?
                        <div style={{paddingTop: "10px"}}>
                          <img className={styles.categoryIcon} alt="img" src={selectedFile ? selectedFile : ""}/>
                          <div className={styles.changeImage} onClick={() => handleImageUpload()}>
                            <input
                              type="file"
                              ref={fileInputRef}
                              onChange={(e) => handleFileChange(e)}
                              style={{display: "none"}}
                            />
                            <button className={styles.alterarIcon}>Alterar</button>
                          </div>
                        </div>
                        :
                        <div style={{padding: "10px 0", display: "flex", alignItems: "center", justifyContent: "center"}}>
                          <img  src={`${Url}/image/${protocol.uri}`} style={{maxWidth: "80px", maxHeight: "80px", padding: "0.5rem", borderRadius: "4px", objectFit: "cover", backgroundColor: "var(--fotoOpacity)"}} alt="icon" />
                        </div>
                      }
                      {
                        selectedCategory === protocol ?
                        <input 
                          className={styles.editName}
                          ref={editRef}
                          onChange={(e) => setEditNome(e.target.value)}
                          placeholder="Nome da categoria..."
                          value={editNome}
                          onKeyDown={(event) => {
                            if (event.key === "Escape"){
                              setSelectedCategory("");
                            }
                            else if (event.key === "Enter") {
                              getAlertEdit();
                            }
                          }}
                        />
                        :
                        <p title={protocol.name ? protocol.name : ""}>{protocol.name ? protocol.name : "-"}</p>
                      }
                      <div className={styles.actions}>
                        {
                          selectedCategory === protocol ?
                          <HiCheck onClick={() => getAlertEdit()} className={styles.icon} size={22}/>
                          :
                          <HiPencil onClick={() => {setShowAdd(false); handleEditButton(protocol)}} className={styles.icon} size={22}/>
                        }
                        <HiTrash className={styles.icon} onClick={() => setDeleteProtocol(<DeleteModal close={setDeleteProtocol} objectId={protocol.id} objectName={`a categoria ${protocol.name}`} deleteFunction={getAlertDelete}/>)} size={22}/>
                        </div>
                      </div>
                    )
                  :
                  <div className={styles.noData}>
                    <p>Não existem dados</p>
                  </div>
                }
              </div>
              {
                previousPageCategories || nextPageCategories ?
                <div className={styles.arrows}>
                  <TbArrowBigLeftLineFilled size={28} color={previousPageCategories ? "" : "#00000000"} onClick={() => handlePageChangeCategories(false)}/>
                  {currentPageCategories ? currentPageCategories : ""}
                  <TbArrowBigRightLineFilled size={28} color={nextPageCategories ? "" : "#00000000"} onClick={() => handlePageChangeCategories(true)}/>
                </div>
                : ""
              }
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default ProtocolosCategorias;